export { default } from './NewsCard';
